/**
 * Authentication utility functions
 * Centralized helper for authentication-related operations
 */

/**
 * Get authorization headers for API requests
 * Used as a fallback for iOS Safari and other browsers where cookies may not work properly
 * @returns {Object} Headers object with Authorization bearer token if available
 */
export const getAuthHeaders = () => {
  const storedToken = localStorage.getItem('session_token');
  return storedToken ? { 'Authorization': `Bearer ${storedToken}` } : {};
};
